module.exports = __webpack_public_path__ + "static/media/success-dark.b4497272.svg";